import React, { PureComponent, Fragment } from 'react'
import _ from 'lodash'
import LOG from '../logging/Logger'

const DEFAULT_DEBOUNCE = 500

const resetTimeout = (id, newID) => {
  clearTimeout(id)
  return newID
}

export class Autosave extends PureComponent {
  state = {
    timeout: null,
    saved: false,
    lastSavedFields: null,
    lastSavedJumpFields: null
  }

  componentDidMount() {
    this.setState((state, props) => ({
      lastSavedFields: props.saveFields,
      lastSavedJumpFields: props.jumpFields
    }))
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props, prevProps)) {
      if (this.props.saveJumpFields) {
        if (
          !_.isEqual(this.props.saveFields, this.state.lastSavedFields) ||
          !_.isEqual(this.props.jumpFields, this.state.lastSavedJumpFields)
        ) {
          this.props.onSaveAll(this.props.saveFields, this.props.jumpFields)
          this.setState((state, props) => ({
            lastSavedFields: props.saveFields,
            lastSavedJumpFields: props.jumpFields,
          }))
        } else if (this.props.onSaveAllNoop) {
          this.props.onSaveAllNoop()
        }
      } else if (
        !_.isEqual(this.props.saveFields, this.state.lastSavedFields)
      ) {
        this.setState((state, props) => ({
          timeout: resetTimeout(
            this.state.timeout,
            setTimeout(
              this.saveValue,
              props.debounce ? props.debounce : DEFAULT_DEBOUNCE
            )
          )
        }))
      }
    }
  }

  saveValue = () => {
    this.props.onSave(this.props.saveFields)
    this.setState((state, props) => ({
      saved: true,
      lastSavedFields: props.saveFields
    }))
    setTimeout(
      () =>
        this.setState({
          saved: false
        }),
      this.props.debounce ? this.props.debounce : DEFAULT_DEBOUNCE
    )
  }

  render() {
    LOG.debug('Render: AutoSave')

    return <Fragment>{this.props.children}</Fragment>
  }
}

export default Autosave
